export default class SortOutEvent {
    export() {
        return {
            sort_out_type: this.sortOutType.trim(),
        };
    }
}
